// Array of food images for the hero section carousel
export const foodImages = [
  {
    id: 1,
    name: 'Grilled Salmon',
    image: 'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=400&h=400&fit=crop',
    color: '#FFA500',
  },
  {
    id: 2,
    name: 'Fresh Salad',
    image: 'https://images.unsplash.com/photo-1540189549336-e6e99c3679fe?w=400&h=400&fit=crop',
    color: '#90EE90',
  },
  {
    id: 3,
    name: 'Protein Bowl',
    image: 'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=400&h=400&fit=crop',
    color: '#FFD700',
  },
  {
    id: 4,
    name: 'Chicken Breast',
    image: 'https://images.unsplash.com/photo-1598103442097-8b74394b95c6?w=400&h=400&fit=crop',
    color: '#FF6347',
  },
];
